var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h1',{staticClass:"has-text-weight-semibold"},[_vm._v(_vm._s(_vm.heading))]),_c('p',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }